import React from 'react';
import { useSelector } from 'react-redux';
import logo from '../assets/images/logo.png';

const Navbar = ({ setHome }) => {
  const cart = useSelector((state) => state.cart);
  
  const totalItemsInCart = cart.reduce(
    (count, cartItem) => count + cartItem.quantity,
    0
  );

  return (
    <nav className="bg-[#171C2A] py-4">
      <div className="navBar">
        <a href="#" onClick={() => setHome(true)}>
          <img src={logo} alt="LWS" className="max-w-[140px]" />
        </a>
        <div className="flex gap-4">
          <a
            href="#"
            className="navHome"
            id="lws-home"
            onClick={() => setHome(true)}
          >
            Home
          </a>
          <a
            href="#"
            className="navCart"
            id="lws-cart"
            onClick={() => setHome(false)}
          >
            <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
            <span id="lws-totalCart">{totalItemsInCart}</span>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
